<div class="notifications-viewport" [class.notifications-fixed]="variant() === 'fixed'">
  @if (current; as notification) {
    <div
      class="card shadow-sm w-border rounded-3 mb-2 notifications-card"
      animate.enter="notification-enter"
      animate.leave="notification-leave"
      (click)="open()"
      [attr.aria-label]="notification.important ? ('HOMEMYLATESTNOTIFICATIONIMPORTANT' | translate) : null"
    >
      <div class="card-body notification-card-body">
        <div class="d-flex flex-column">
          <div class="notification-header">
            <div class="notification-avatar">
              <app-avatar
                [image]="notification.image?.url?.responsive ?? ''"
                [name]="notification.title ?? ''"
                [subTitle]="notification.body ?? ''"
                [date]="createDate(notification.created_at)"
                [type]="'large'">
              </app-avatar>
            </div>

            <div class="notification-content">
              <div class="notification-headline">
                <app-content
                  [fontSize]="'fs-small'"
                  [fontColor]="'text-primary'"
                  [fontDecoration]="'fw-bold'"
                  [class]="'me-2 text-wrap d-block'"
                  [class.truncate-text-two-lines]="variant() === 'fixed'">
                  {{ notification.title }}
                </app-content>

                <app-content
                  [fontSize]="'fs-verysmall'"
                  [fontColor]="'text-muted'"
                  [class]="'d-block'"
                  [fontDecoration]="'fst-italic'">
                  {{ 'POSTEDAT' | translate }} {{ notification.created_at | date : 'medium' }}
                </app-content>
              </div>

              <div class="notification-body">
                <app-content
                  [fontSize]="'fs-small'"
                  [fontColor]="'text-muted'"
                  [truncateLines]="2"
                  [type]="'richtext'"
                  [innerHTML]="notification.body ?? ''">
                </app-content>
              </div>

              @if(notifcationIsCalendarEventOpenInvitation()) {
                <div class="notification-actions">
                  <div class="notification-actions-main">
                    <!-- TODO: should also be used for video invitations in the future -->
                    <!-- TODO: this alters the total height of the notification but looks better IMO, @Steph needs to verify -->
                    <app-form-button
                      [text]="'INVYES' | translate"
                      [cssClass]="'e-success e-verysmall compact-button'"
                      [disabled]="isCalendarEventCapacityLimitReached(notification)"
                      (click)="sendCalendarRsvpYes(); $event.stopPropagation()"
                      >
                    </app-form-button>
                    <app-form-button
                      [text]="'INVMAYBE' | translate"
                      [cssClass]="'e-warning e-verysmall compact-button'"
                      (click)="sendCalendarRsvpMaybe(); $event.stopPropagation()"
                      >
                    </app-form-button>
                    <app-form-button
                      [text]="'INVNO' | translate"
                      [cssClass]="'e-danger e-verysmall compact-button'"
                      (click)="sendCalendarRsvpNo(); $event.stopPropagation()"
                      >
                    </app-form-button>
                  </div>
                </div>
              }

              <div class="notification-actions">
                <div class="notification-actions-main">
                  @if (notification.channel) {
                    <app-pill
                      [type]="'small'"
                      [rounded]="true"
                      [bgColor]="'bg-primary'"
                      [fontColor]="'text-white'">
                      {{ notification.channel.toUpperCase() | translate }}
                    </app-pill>
                  }
                </div>
              </div>
            </div>

            <div class="notification-rail">
              @if(notification.read === false && notification.important === true){
                <div class="notif-bell-static notif-bell--active">
                  <span class="notif-bell-container">
                    <app-icon-badge
                      [style]="'notification'"
                      [icon]="'notifications'"
                      [fontColor]="'text-danger'">
                    </app-icon-badge>
                  </span>
                </div>
              }

              <div class="notification-rail-actions">
                <app-form-button
                  [style]="'btn'"
                  [cssClass]="'btn-link p-0 text-muted notification-menu-button'"
                  [icon]="'open_in_full'"
                  [iconClass]="'fs-6'"
                  [ariaLabel]="'NOTIFICATIONOPENINFULL' | translate"
                  (click)="openDetails($event)">
                </app-form-button>
                @if (notification.channel !== 'chat') {
                  <div class="notification-actions-menu">
                    <div class="dropdown">
                      <button
                        #actionsMenuTrigger
                        (click)="stopPrevent($event)"
                        type="button"
                        class="btn btn-link p-0 text-muted notification-menu-button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                        <app-icon-badge [style]="'notification'" [icon]="'more_horiz'"></app-icon-badge>
                      </button>

                      <ul class="dropdown-menu dropdown-menu-end">
                        @if(notification.read){
                          <li><app-link (click)="setUnRead($event, actionsMenuTrigger)" [title]="('BELLMARKASUNREAD' | translate)" [style]="'dropdown'">{{ ('BELLMARKASUNREAD' | translate) }}</app-link></li>
                        } @else {
                          <li><app-link (click)="setRead($event, actionsMenuTrigger)" [title]="('BELLMARKASREAD' | translate)" [style]="'dropdown'">{{ ('BELLMARKASREAD' | translate) }}</app-link></li>
                        }
                      </ul>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>

@if (dialogNotification; as expanded) {
  <ejs-dialog
    target="body"
    class="simple-dialog notification-detail-dialog"
    [visible]="true"
    [isModal]="true"
    [allowDragging]="false"
    [width]="'min(600px, 90vw)'"
    [showCloseIcon]="true"
    [zIndex]="9999"
    (close)="closeDetails()">
    <ng-template #header>
      <app-headline [title]="expanded.title ?? ''"></app-headline>
    </ng-template>
    <ng-template #content>
      <div class="notification-dialog-content">
        <div class="d-flex flex-wrap align-items-center gap-2 mb-3">
          @if (expanded.channel) {
            <app-pill
              [type]="'default'"
              [rounded]="true"
              [bgColor]="'bg-primary'"
              [fontSize]="'fs-small'"
              [fontColor]="'text-white'">
              {{ expanded.channel.toUpperCase() | translate }}
            </app-pill>
          }
          <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'">
            {{ 'POSTEDAT' | translate }} {{ expanded.created_at | date : 'medium' }}
          </app-content>
        </div>
        <app-content [type]="'richtext'" [innerHTML]="expanded.body ?? ''"></app-content>
      </div>
      <div class="notification-dialog-actions d-flex flex-wrap gap-2 justify-content-end mt-3">
        <app-form-button
          [style]="'btn'"
          [cssClass]="'btn-outline-primary'"
          [text]="(expanded.read ? 'BELLMARKASUNREAD' : 'BELLMARKASREAD') | translate"
          (click)="toggleDialogRead()">
        </app-form-button>
        @if (hasContentRoute(expanded)) {
          <app-form-button
            [style]="'btn'"
            [cssClass]="'btn-primary'"
            [text]="'NOTIFICATIONGOTOCONTENT' | translate"
            (click)="goToDialogContent()">
          </app-form-button>
        }
      </div>
    </ng-template>
  </ejs-dialog>
}
